import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
// import "./cycleCountSetting.css";
import { getGlobals } from "../../Configs";
import moment from "moment";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import HeaderComponent from "./processComponent/HeaderComponent";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import BoxPalletReceiptDetail from "./processComponent/BoxPalletReceiptDetail";
import { useLocation } from "react-router-dom";
import CmpModal from "../../Component/Common/ReuseableComponent/CmpModal";

const BoxPalletReceipt = () => {
  const uMediaQuery = useMediaQuery("(max-width:390px)");
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const status = ["All", "Enter", "Post"];

  const [palleteSummary, setPalleteSummary] = useState([]);
  const [open, setOpen] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // Store full row data

  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const location = useLocation();
  const vPathName = location.pathname;
  const title = vPathName === "/boxpalletreceipt" ? "Receipt" : "Issue";
  //let title = "Box Pallet" + vPathName === "/boxpalletreceipt" ?   "Receipt" : "Issue"
  let trnType = vPathName === "/boxpalletreceipt" ? "I" : "O";

  const [filterState, setFilterState] = useState({
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toISOString(),
    dateTo: new Date().toISOString(),
    location: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
    status: "All",
    truckId: [],
  });

  let initHeadError = {
    truckId: "",
  };
  const [headErrors, setHeadErrors] = useState(initHeadError);

  const fValidationHead = () => {
    let isValid = true;
    const newError = {
      truckId: "",
    };
    if (
      filterState?.truckId.length === 0 ||
      filterState?.truckId == undefined ||
      filterState?.truckId === null ||
      filterState?.truckId === ""
    ) {
      newError.truckId = "Truck Id is required.";
      isValid = false;
    }

    setHeadErrors((prevError) => ({
      ...prevError,
      ...newError,
    }));

    if (!isValid) {
      const firstInvalidField = Object.keys(newError).find(
        (key) => newError[key]
      );
      document.querySelector(`[name="${firstInvalidField}"]`)?.focus();
    }

    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilterState((prev) => {
      const updatedDetailObj = {
        ...prev,
        [name]: value,
      };

      // Reset fields if barcode is empty or backspace is pressed
      if (
        updatedDetailObj?.truckId.trim() === "" ||
        event.nativeEvent.inputType === "deleteContentBackward"
      ) {
        updatedDetailObj.truckId = value;
      }

      return updatedDetailObj;
    });
  };

  const baseURL = getGlobals().API_BASE_URL;

  const handleLoadBtn = () => {
    // const isHeadValid = fValidationHead();
    // if (!isHeadValid) return;
    getPalleteSummary();

    if (vMediaQuery) {
      setOpenFilterModal(false);
    }
  };

  const handleRowClick = (params) => {
    setSelectedRow(params.row);
    setOpen(true);
  };

  const handleAddNew = () => {
    setSelectedRow({
      A_VocNo: 0,
      A_Loc: vRdxuserLoc.length > 0 ? vRdxuserLoc[0]?.UID : [],
      A_TruckId: [],
      A_Status: "ENTER",
    });
    setOpen(true);
  };

  const fFilter = () => {
    setOpenFilterModal(true);
  };

  const ftruckIdScan = (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setHeadErrors(initHeadError);
      const isHeadValid = fValidationHead();
      if (!isHeadValid) return;
      getTruckId();
    }
  };

  const getPalleteSummary = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    setPalleteSummary([]);
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/getBoxPalletReceivingSummary`,
        fcheck_null_undefine_replace_empty({
          FromDate: moment(filterState?.dateFrom).format("MM/DD/YYYY"),
          ToDate: moment(filterState?.dateTo).format("MM/DD/YYYY"),
          Loc: filterState?.location,
          Status: filterState?.status,
          TruckId: filterState?.truckId?.UId,
          IO: trnType,
        })
      );

      if (response?.status === 200) {
        setPalleteSummary(response?.data?.ResultSet);
        loader.style.display = "none";
      } else {
        setPalleteSummary([]);
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
      loader.style.display = "none";
    }
  };
  const getTruckId = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}WmsBoxPallet/AttributesBoxPalletTruck`,
        {
          TruckId: filterState?.truckId,
        }
      );

      if (response?.status === 200) {
        let result = response?.data?.ResultSet.TruckRec;
        if (result.length > 0) {
          setFilterState((prev) => ({
            ...prev,
            truckId: response?.data?.ResultSet.TruckRec[0],
          }));
        } else {
          fAlertToast("FAILED", "Truck Id not found");
        }
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);
    } finally {
      loader.style.display = "none";
    }
  };
  console.log(filterState);

  useEffect(() => {
    getPalleteSummary();
  }, [vPathName]);

  return (
    <div className="div-container">
      <Box pt={2}>
        {vMediaQuery ? (
          <Grid container>
            <Grid item xs={6} marginTop={uMediaQuery ? 0.5 : 0}>
              <Typography
                variant={vMediaQuery ? "subtitle2" : "h6"}
                gutterBottom
                color={"primary"}
                sx={{ fontWeight: 600, mt: 0.5 }}
              >
                Box Pallet {title}
              </Typography>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={fFilter}
              >
                Filter
              </Button>
            </Grid>
            <Grid item xs={3} textAlign={"right"}>
              <Button
                variant="contained"
                sx={{
                  height: "30px",
                  mt: 0.5,
                  textTransform: "capitalize",
                }}
                onClick={handleAddNew}
              >
                New
              </Button>
            </Grid>
          </Grid>
        ) : (
          <>
            <Typography
              variant="h6"
              gutterBottom
              color={"primary"}
              sx={{ fontWeight: 600 }}
            >
              Box Pallet {title}
            </Typography>

            <HeaderComponent
              handleAddNew={handleAddNew}
              status={status}
              handleChange={handleChange}
              filterState={filterState}
              setFilterState={setFilterState}
              vRdxDBLocation={vRdxuserLoc}
              handleLoadBtn={handleLoadBtn}
              ftruckIdScan={ftruckIdScan}
              headErrors={headErrors}
            />
          </>
        )}

        <Box
          sx={{
            mt: xMediaQuery ? 2 : 5,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: vMediaQuery ? "75vh" : "70vh",
            width: "100%",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            components={{
              Toolbar: GridToolbar,
            }}
            //  className="grid-table"
            rows={palleteSummary ? palleteSummary : ""}
            getRowId={(v) => v.A_VocNo}
            columns={[
              {
                field: "A_VocNo",
                headerName: "Voc No",
                width: xMediaQuery ? 80 : 140,
              },
              {
                field: "Location_Name",
                headerName: "Location",
                width: xMediaQuery ? 220 : 0,
                flex: xMediaQuery ? 0 : 1,
              },
              {
                field: "A_PostDt",
                headerName: "Date",
                width: xMediaQuery ? 90 : 100,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
              },
              {
                field: "TrucK_Name",
                headerName: "Truck Name",
                width: xMediaQuery ? 180 : 0,
                flex: xMediaQuery ? 0 : 1,
              },
              {
                field: "A_Status",
                headerName: "Status",
                width: 100,
              },
              {
                field: "A_EnBy",
                headerName: "A_EnBy",
                width: xMediaQuery ? 80 : 100,
                hide: true,
              },
              {
                field: "A_EnDt",
                headerName: "A_EnDt",
                width: xMediaQuery ? 80 : 100,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
                hide: true,
              },
              {
                field: "A_EdBy",
                headerName: "A_EdBy",
                width: 80,
                hide: true,
              },
              {
                field: "A_EdDt",
                headerName: "A_EdDt",
                width: xMediaQuery ? 80 : 100,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
                hide: true,
              },
              {
                field: "A_ApBy",
                headerName: "A_ApBy By",
                width: xMediaQuery ? 150 : 200,
                hide: true,
              },
              {
                field: "A_ApDt",
                headerName: "A_ApDt",
                width: 95,
                valueFormatter: ({ value }) =>
                  moment(value).format("DD/MM/YYYY"),
                hide: true,
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            onRowClick={handleRowClick}
            hideFooter
          />
        </Box>

        <CmpModal
          open={open}
          onClose={() => {
            setOpen(false);
            getPalleteSummary();
          }}
          title={`BoxPallet ${title} Detail`}
          width={vMediaQuery ? "95%" : xMediaQuery ? "85%" : "70%"}
          height={vMediaQuery ? "80vh" : "85vh"}
          component={
            <BoxPalletReceiptDetail
              open={open}
              closeModal={() => {
                setOpen(false);
                getPalleteSummary();
              }}
              vMediaQuery={vMediaQuery}
              uMediaQuery={uMediaQuery}
              rowData={selectedRow} // Pass full row data to modal
              xMediaQuery={xMediaQuery}
              trnType={trnType}
            />
          }
        />
        {vMediaQuery && (
          <CmpModal
            open={openFilterModal}
            onClose={() => setOpenFilterModal(false)}
            title="Filter"
            width={"95%"}
            height={"auto"}
            component={
              <HeaderComponent
                closeModal={() => setOpenFilterModal(false)}
                status={status}
                handleChange={handleChange}
                handleLoadBtn={handleLoadBtn}
                filterState={filterState}
                setFilterState={setFilterState}
                vRdxDBLocation={vRdxuserLoc}
                headErrors={headErrors}
                ftruckIdScan={ftruckIdScan}
              />
            }
          />
        )}
      </Box>
    </div>
  );
};

export default BoxPalletReceipt;
